const getPermissions = (context = {}) =>
  Array.isArray(context?.permissions) ? context.permissions : [];

const getRoles = (context = {}) =>
  Array.isArray(context?.roles) ? context.roles : [];

const hasPermission = (context = {}, permissionKey) =>
  getPermissions(context).includes(permissionKey);

const hasAnyPermission = (context = {}, permissionKeys = []) =>
  permissionKeys.some((permissionKey) => hasPermission(context, permissionKey));

export const isProviderUser = (context = {}) =>
  hasPermission(context, 'provider:self_service') ||
  getRoles(context).includes('provider') ||
  context?.userType === 'provider';

export const canManageDbqForms = (context = {}) =>
  hasPermission(context, 'admin:dbq_forms');

export const canManageDbqMedicalOpinion = (context = {}) =>
  hasPermission(context, 'admin:casegpt_content');

export const canManageDbqRequests = (context = {}) =>
  hasPermission(context, 'claims:edit') &&
  hasAnyPermission(context, ['claims:view_all', 'claims:view_assigned']);

export const canFinalizeDbqReview = (context = {}) =>
  hasPermission(context, 'claims:approve_for_va');

export const canDeleteDbq = (context = {}) =>
  canFinalizeDbqReview(context);

const canManageDbqCollaboration = (context = {}) =>
  canManageDbqRequests(context) || canManageDbqForms(context);

export const isDbqCaseManagerActor = (context = {}) =>
  canManageDbqRequests(context) &&
  !canFinalizeDbqReview(context) &&
  !canManageDbqForms(context) &&
  !isProviderUser(context);

export const canEditManagedMedicalOpinion = (context = {}) =>
  canManageDbqMedicalOpinion(context) ||
  canManageDbqForms(context) ||
  isProviderUser(context) ||
  isDbqCaseManagerActor(context);

export const canEditDbqFields = (context = {}) =>
  isProviderUser(context) ||
  canManageDbqRequests(context) ||
  canManageDbqForms(context);

export const canResolveAnyDbqComment = (context = {}) =>
  isProviderUser(context) || canFinalizeDbqReview(context);

export const canCreateDbqSuggestion = (context = {}) =>
  canManageDbqCollaboration(context);

export const canReviewDbqSuggestions = (context = {}) =>
  isProviderUser(context) || canManageDbqForms(context);

export const canDismissDbqSuggestion = (context = {}) =>
  canManageDbqCollaboration(context);

export const canCommentOnDbq = (context = {}) =>
  canManageDbqRequests(context) || isProviderUser(context);

export const canViewDbqAudit = (context = {}) => canManageDbqCollaboration(context);
